// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3ZLGi","navText":"Navbar_navText__11kpq","navLogo":"Navbar_navLogo__jJiC5","imgLogo":"Navbar_imgLogo__qP33V"};